import { getScreenshotWithPosition } from '@/libs/screenshot';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';

export function updateImagesOnConfigurationChange() {
    const selectedCaseId = useStoreProjectStructure().selectedCaseId;
    if (!selectedCaseId) {
        console.error('Нет выбранного шкафа для сохранения изображения');
        return;
    }
    const newImage = getScreenshotWithPosition(300, 300);
    // console.log('Скриншот проекта обновлён', selectedCaseId);
    useStoreProjectStructure().setProjectImage(newImage);
    useStoreProjectStructure().setCaseImageById(selectedCaseId, newImage);
}
